import { Injectable } from '@angular/core';
import * as XLSX from 'xlsx';

@Injectable()
export class ExcelService {

  constructor() { }

  public exportAsExcelFile(json: any[], excelFileName: string): void {
    var worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
    worksheet['A1'].s = {
      fill: {fgColor: {rgb: "D3D3D3"}},
      font: {name: 'Arial', sz:10, bold: true},
      alignment: { wrapText: true, vertical: 'bottom', horizontal: 'center' }
    };

    const workbook: XLSX.WorkBook = { Sheets: { 'report': worksheet }, SheetNames: ['report'] };
    XLSX.writeFile(workbook, excelFileName + '_export_' + new Date().getTime() + '.xlsx')
  }

  
}



// WEBPACK FOOTER //
// ./src/app/excel.service.ts